import type { DevToolboxIsEnabled } from "./types";

/** Default host guard: development builds only. */
export function createNodeEnvDevToolboxEnabled(): DevToolboxIsEnabled {
  return () => process.env.NODE_ENV === "development";
}
